module.exports = __webpack_public_path__ + "img/download.8800cb6f.svg";